module.exports = __webpack_public_path__ + "static/media/infiniti-pin.a31b0ddc.svg";